import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import About from "./components/About";

import Services from "./components/Services";
import Contact from "./components/Contact";
import Footer from "../src/components/Footer"
import Admin from "../src/components/admin/showallcontact"
const App = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin/contacts" element={<Admin />} />
      </Routes>
      <Footer/>
    </Router>
  );
};

export default App;
